import { Component, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Broadcaster } from './shared/index';
import {
  MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, HiddenFooter,
  SidemenuToCalendarEvent, SidemenuToViewFacilityEvent, SidemenuSubCategory, HandleSideMenuWithAuth, SetAllMemberCheck, ConfirmationPopup
} from './shared/message.event';
import { AppService } from './app.service';
import { CONSTANT_MESSAGES } from './constants/constants-messages';
import { CONSTANT_VALUES } from './constants/constant-values';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [RouterModule]
})
export class AppComponent implements OnInit {

  public stringConstants = CONSTANT_MESSAGES;
  private hideMenu: any;
  private hideFooter: any;
  public facilityData: any;
  public oneAtATime: boolean = true;
  public loaderView = true;
  private _router;
  public shouldSlide: boolean = false;
  public popUpMessage = CONSTANT_MESSAGES.LOGOUT_CONFIRMATION;
  public cancleButton = "CANCEL";
  public status: Object = {
    isFirstOpen: true,
    isFirstDisabled: false
  };
  private selectedSubMenu = '';
  private selectedClass = '';
  private selectedMenu = '';
  public popupTitle = '';
  public menuAuth = {
    member: true,
    activities: true,
    calendar: true,
    staff: true,
    feed: true,
    feedback: true,
    analytics: true,
    manageProfile: true,
    account: true,
    loyalty: true,
    events: true,
    links: true,
    groupBookings: true
  };

  public sideMenuActiveMember = false;
  public sideMenuActiveFacility = false;
  private sideMenuActiveEvents = false;
  public appVersion: any;
  private vendor;
  public isPrivacyPolicy: boolean = true;
  public isSupport: boolean = true;
  public sideMenuActiveCalendar = false;
  private sideMenuActiveLoyalty = false;

  constructor(private appService: AppService, private messageEvent: MessageEvent, private signInEvent: SignInEvent,
    private broadcaster: Broadcaster, private sidemenuToViewFacilityEvent: SidemenuToViewFacilityEvent,
    private viewContainerRef: ViewContainerRef, private openFrameEvent: OpenFrameEvent, private loaderEvent: LoaderEvent,
    private facilityListEvent: FacilityListEvent, private router: Router, private sidemenuToCalendarEvent: SidemenuToCalendarEvent,
    private sidemenuSubCategory: SidemenuSubCategory, public handleSideMenuWithAuth: HandleSideMenuWithAuth,
    public hiddenFooter: HiddenFooter, private setAllMemberCheck: SetAllMemberCheck, private confirmationPopup: ConfirmationPopup) {
    this._router = router;
    this.appService.getAppVersion().then((result: any) => {
      this.appVersion = result.appVersion;
      localStorage.setItem('appVersion', this.appVersion);
    });
  }

  ngOnInit() {
    this.registerTypeBroadcast();
    if (localStorage.getItem('vendor')) {
      this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
      if (this.vendor.role == CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
        this.appService.getFacilityByClub(this.vendor._id);
      } else if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
        if (this.vendor.subVendors.length > 0) {
          let subVendor = this.vendor.subVendors[0];
          this.appService.getFacilityByClub(subVendor._id);
        }
      } else {
        this.appService.getFacilityByClub(this.vendor.vendorId);
      }

      if (localStorage.getItem('vendor_facilityData')) {

        this.facilityData = JSON.parse((localStorage.getItem('vendor_facilityData')));
      }
    }
  }

  getMenuStatus(state) {
    try {
      this.emitTypeBroadcast(!state);
      this.appService.setShouldSlide(state);
      return (!state);
    } catch (e) {
      console.log(e);
    }
  }

  registerTypeBroadcast() {
    try {
      this.signInEvent.on()
        .subscribe(message => {
          this.hideMenu = message;
        });

      this.hiddenFooter.on()
        .subscribe(isShow => {
          this.isPrivacyPolicy = isShow.privacypolicy;
          this.isSupport = isShow.support;
          this.hideFooter = isShow.footer;
        });

      this.handleSideMenuWithAuth.on()
        .subscribe(value => {
          if (value) {
            this.renderRoleWiseMenu(
              value.role,
              value.isFeedbackEnabled,
              value.allowPayment,
              value.allowLoyalty,
              value.isEventEnabled,
              value.isLinksEnabled,
              value.isGroupClassesEnabled
            );
          }

        });

      this.loaderEvent.on()
        .subscribe(message => {
          this.loaderView = message;
        });

      this.facilityListEvent.on()
        .subscribe(message => {
          this.facilityData = message;
        });

      this.openFrameEvent.on()
        .subscribe(message => {
          if (typeof message === 'boolean') {
            this.shouldSlide = message;
            this.sideMenuActiveMember = message;
            this.sideMenuActiveFacility = message;
            this.sideMenuActiveCalendar = message;
            this.sideMenuActiveLoyalty = message;
            this.sideMenuActiveEvents = message;
          }
        });

      this.sidemenuSubCategory.on()
        .subscribe(obj => {
          //   alert(category);
          this.selectedSubMenu = obj.category;
          this.selectedClass = 'subactive';
          this.selectedMenu = obj.menu;
        });

    } catch (e) {
      console.log(e);
    }
  }
  // feed is accessible to both admin and staff

  renderRoleWiseMenu(
    role,
    handleSideMenuWithAuth,
    allowPayment,
    allowLoyalty = false,
    isEventEnabled = false,
    isLinksEnabled = false,
    isGroupClassesEnabled = false
  ) {
    switch (role) {
      case 'vendor admin':
        this.menuAuth = {
          member: false,
          activities: true,
          calendar: false,
          staff: false,
          feed: false,
          feedback: !handleSideMenuWithAuth,
          analytics: false,
          manageProfile: false,
          account: !allowPayment,
          loyalty: !allowLoyalty,
          events: !isEventEnabled,
          links: !isLinksEnabled,
          groupBookings: !isGroupClassesEnabled
        };
        break;
      case 'staff':
        this.menuAuth = {
          member: true,
          activities: true,
          calendar: false,
          staff: false,
          feed: true,
          feedback: true,
          analytics: false,
          manageProfile: false,
          account: true,
          loyalty: true,
          events: true,
          links: true,
          groupBookings: true
        };
        break;
      case 'superAdmin':
        this.menuAuth = {
          member: true,
          activities: false,
          calendar: false,
          staff: false,
          feed: true,
          feedback: true,
          analytics: true,
          manageProfile: false,
          account: true,
          loyalty: true,
          events: !isEventEnabled,
          links: !isLinksEnabled,
          groupBookings: !isGroupClassesEnabled
        };
        break;
    }
  }

  emitTypeBroadcast(state) {
    try {
      this.messageEvent.fire(state);
    } catch (e) {
      console.log(e);
    }
  }

  emitOpenFrameEvent() {
    try {
      this.openFrameEvent.fire(false);
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * Show Category list on side menu for Booking Calendar
   *
   * @param category
   *
   * @response got list of category
   */

  // emitTypeBroadcast will only call when there is no data loss. It is only for vendor admin and staff.
  showCalendarWithFacility(category, event) {
    try {
      localStorage.removeItem('view');
      localStorage.removeItem('facilityIdOnViewSummary');
      this.appService.setCurrentDate(null);
      this.appService.setCategoryForCalendar(category);
      localStorage.setItem('categorySideMenu', 'yes');
      if (!localStorage.getItem('needPopup')) {
        this.emitTypeBroadcast(false);
      }
      if (window.location.pathname.indexOf('calendar') > -1) {
        this.emitOpenFrameEvent();
        this.sidemenuToCalendarEvent.fire(category);
      } else {
        this.redirectToanotherPage('/calendar');
        //this._router.navigate(['/calendar']);

      }
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * Show Category List on side menu for Facility
   *
   * @param category
   *
   * @response got list of category
   */
  showFacilityWithCategory(category) {
    try {
      localStorage.setItem('currentCategory', btoa(category));
      this.emitTypeBroadcast(false);
      if (window.location.pathname.indexOf('addfacility') > -1) {
        this.emitOpenFrameEvent();
        this.sidemenuToViewFacilityEvent.fire(category);
      } else {
        localStorage.removeItem('facility');
        this.redirectToanotherPage('/addfacility');
        //this._router.navigate(['/addfacility']);
      }
    } catch (e) {
      console.log(e);
    }
  }

  logout(bool: boolean) {
    try {
      if (bool) {
        this._router.navigate(['/logout']);
      }
    } catch (e) {
      console.log(e);
    }
  }
  shoSomeThing() {
    alert('hi');
  }

  showConfirmationPopup(pageName) {
    if (localStorage.getItem('needPopup')) {
      this.confirmationPopup.fire(pageName);
      return true;
    } else {
      return false;
    }
  }

  redirectToanotherPage(pageName) {
    if (!this.showConfirmationPopup(pageName)) {
      this._router.navigate([pageName]);
    }
  }

  logOut(popupObj) {
    // if (!this.showConfirmationPopup('')) {
    //   popupObj.showChildModal();
    // }
    if (localStorage.getItem('needPopup')) {
      this.redirectToanotherPage('/logout')
    } else {
      popupObj.showChildModal();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts